/**
 * Returns the default contract end date: the same local day and month in the
 * following calendar year. When that date does not exist (29 February), the
 * last valid day of the target month is used.
 */
export function defaultContractEndDate(startDate: Date | null | undefined): Date | null {
	if (!(startDate instanceof Date) || Number.isNaN(startDate.getTime())) return null;

	const targetYear = startDate.getFullYear() + 1;
	const month = startDate.getMonth();
	const lastDayOfTargetMonth = new Date(targetYear, month + 1, 0).getDate();
	const day = Math.min(startDate.getDate(), lastDayOfTargetMonth);

	return new Date(targetYear, month, day);
}
